import React from 'react'
import './card-point-sale.scss'
import useModalGeneric from '../../../shared/hooks/useModalGeneric';
import ModalPov from '../../molecules/modalPov/modalPov';

const CardPointSale = (props) => {
    const [isModal, showModal, HideModal] = useModalGeneric(false);

    return (
        <>
            <div className={'f-card-product f-card-point-sale'} onClick={(e)=> { e.preventDefault(); showModal() }}>
                <div className="f-icon-location" />
                <div className="f-text-container">
                    <label className="f-line-1">PUNTOS DE VENTA DÓNDE</label>
                    <label className="f-line-2">COMPRAR</label>
                    <label className="f-line-3">NUESTROS PRODUCTOS</label>
                </div>
            </div>
            {isModal && <ModalPov onClose={HideModal} /> }
        </>
    )
}

export default CardPointSale
